// Port of api/fuel/app/classes/filter/plays.php
import Filter from 'offline/filter/core/filter'
import F from 'offline/filter/constants'

var Plays = Filter.extend({
	filter_type: F.TYPE_GAMES,
	cache_type: F.CACHE_PLAYS,
	result_type: F.RESULT_PLAY,
	pseudo_type: F.PSEUDO_PLAY,
	json_package: 'plays',
	package_types: [F.PACKAGE_GAME, F.PACKAGE_PLAY],
	required_filter: {
		source: {
			plays: true
		}
	},

	configure: function(config, filter) {
		// If play.group is set, switch to game-level results
		if (filter.play && filter.play.group) {
			config.resultType = F.RESULT_GAME
		}
		return config
	},

	search: function(data) {
		data = Filter.prototype.search.call(this, data)
		data.maximum = this._filter.play && this._filter.play.group
			? (this._config.owner.get_count_plays_games ? this._config.owner.get_count_plays_games() : data.maximum)
			: (this._config.owner.get_count_plays ? this._config.owner.get_count_plays() : data.maximum)
		return data
	}
})

export default Plays
